var exports = {
  "i": "ConnectionNagbar.module__message___SnRuTl",
  "q": "ConnectionNagbar.module__indicator___SnRuTl",
};

module.exports = exports;
